module.exports = __webpack_public_path__ + "img/9788957983768.8e3e88bc.jpg";